// extracted by mini-css-extract-plugin
module.exports = {"radio":"_9e1425b4d3--radio--xCQqe","indicator":"_9e1425b4d3--indicator--I7rqt","label":"_9e1425b4d3--label--sOKWo"};